module.exports = b64string => {
  // decode base64 string, remove space for IE compatibility
  const binaryString = window.atob(b64string.replace(/\s/g, ''));
  const len = binaryString.length;
  const bytes = new Uint8Array(len);
  for (let i = 0; i < len; i++) {
    bytes[i] = binaryString.charCodeAt(i);
  }
  return bytes.buffer;
};
